import { Injectable } from '@angular/core';
import { Observable, Subject, map } from 'rxjs';

import { ContentPageletEntryPoint } from 'ish-core/models/content-pagelet-entry-point/content-pagelet-entry-point.model';
import { ContentPagelet } from 'ish-core/models/content-pagelet/content-pagelet.model';
import { JsonLdService } from 'ish-core/services/json-ld/json-ld.service';

@Injectable({ providedIn: 'root' })
export class SeoSchemaService {
  constructor(private jsonLdService: JsonLdService) {}
  private schemaPageletSubject$ = new Subject<ContentPagelet>();

  schemaPagelet$ = this.schemaPageletSubject$.asObservable();

  /**
   * Filters the schema pagelet and its reference from {@link ContentPageletEntryPoint} and {@link ContentPagelet} [] and emit the Schema Pagelet.
   */
  filterSchemaPagelet() {
    return (source$: Observable<{ include: ContentPageletEntryPoint; pagelets: ContentPagelet[] }>) =>
      source$.pipe(
        map(({ include, pagelets }) => {
          let schemaPagelet: ContentPagelet | undefined = undefined;

          const filteredPagelets = pagelets.filter(pagelet => {
            const isNotSchemaPagelet =
              pagelet.definitionQualifiedName !== 'dias_app_sf_pwa_cm:component.ICSA.custom-schema.pagelet2-Component';

            if (!isNotSchemaPagelet) {
              schemaPagelet = pagelet;
            }

            return isNotSchemaPagelet;
          });

          let filteredInclude = include;

          if (schemaPagelet) {
            this.schemaPageletSubject$.next(schemaPagelet);
            filteredInclude = { ...include, pageletIDs: include.pageletIDs.filter(id => id !== schemaPagelet.id) };
          }

          return {
            include: filteredInclude,
            pagelets: filteredPagelets,
          };
        })
      );
  }

  filterContentSchemaPagelet(pagelets: ContentPagelet[]) {
    pagelets.map(pagelet => {
      if (pagelet.definitionQualifiedName === 'dias_app_sf_pwa_cm:component.ICSA.custom-schema.pagelet2-Component') {
        this.schemaPageletSubject$.next(pagelet);
      }
    });

    return pagelets.filter(
      pagelet =>
        pagelet.definitionQualifiedName !== 'dias_app_sf_pwa_cm:component.ICSA.custom-schema.pagelet2-Component'
    );
  }

  setContentPageSchemaData(data?: string) {
    let schema: object[] = undefined;

    if (!data) {
      return;
    }

    try {
      schema = JSON.parse(data) as object[];
      this.jsonLdService.setContentPageData(schema);
    } catch (error) {
      console.error('Error Parsing the Content Page Schema');
    }
  }
}
